import React from 'react';
import Box from '@storeblocks/box';
import Attachments from '../../../components/Attachments';
import { Avatar } from '../../Inbox/Items/styled';
import { BubbleBase, Container, Content, AttachmentWrap } from './styled';
function Bubble(_a) {
    var name = _a.name, time = _a.time, content = _a.content, _b = _a.$left, $left = _b === void 0 ? true : _b, _c = _a.$right, $right = _c === void 0 ? false : _c, attachments = _a.attachments, id = _a.id, taskId = _a.taskId;
    function renderAttachments() {
        return ((attachments === null || attachments === void 0 ? void 0 : attachments.length) > 0 && (React.createElement(AttachmentWrap, null,
            React.createElement(Attachments, { attachments: attachments, taskId: taskId, right: $right }))));
    }
    return (React.createElement(BubbleBase, { "$left": $left, "$right": $right, id: id },
        React.createElement(Box, { style: $right
                ? { flexDirection: 'row-reverse', background: 'inherit' }
                : { background: 'inherit' } },
            React.createElement(Avatar, { name: $right ? 'rebrand/man-heart' : 'rebrand/contact-advisor' }),
            React.createElement(Container, { style: $right ? { alignItems: 'flex-end' } : undefined },
                time,
                React.createElement("span", { "data-hj-suppress": true }, name))),
        React.createElement(Content, { "data-hj-suppress": true }, content),
        renderAttachments()));
}
export default Bubble;
